import React, { useState } from "react";

import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import useForm from "react-hook-form";
import { Link, Redirect } from "react-router-dom";

import config from "../../dashboard-config";

import "./Session.scss";

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  closeButton: {
    textAlign: "right"
  },
  linkContainer: {
    padding: "10px 0 30px 0"
  },
  link: {
    textAlign: "right"
  },
  recovery: {
    backgroundColor: "#228CBD",
    margin: "2vh 0 0 0",
    padding: "20px",
    width: "70%",

    "&:hover": {
      backgroundColor: "#262A3F"
    }
  },
  termsBar: {
    background: "rgba(37, 42, 63, 0.5)",
    bottom: "0",
    fontSize: "0.8em",
    marginRight: theme.spacing(2),
    position: "absolute"
  },
  termLinks: {
    marginLeft: "auto",
    textDecoration: "none"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%"
  }
}));

const Recovery = () => {
  const classes = useStyles();
  const [isError, setIsError] = useState(false);
  const [isSuccessfulText, setIsSuccessfulText] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const { register, handleSubmit } = useForm({});

  const getRecovery = async data => {
    /* URI encoding object */
    let details = {
      email: data.email
    };

    let formBody = [];

    for (let property in details) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(details[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }

    fetch(`${config.wavefleetUrl}/forgot-password/`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded"
      }),
      body: formBody
    })
      .then(res => {
        if (res.status === 200) {
          setIsSuccessfulText(true);
          setTimeout(() => {
            setIsSuccessful(true);
          }, 3000);
        } else {
          setIsError(true);
        }
      })
      .catch(e => setIsError(true));
  };

  if (isSuccessful) {
    return <Redirect to="/login" />;
  }

  return (
    <div className="auth-container">
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{ minHeight: "94vh" }}
      >
        <Grid
          item
          xs={5}
          style={{
            backgroundColor: "#FFF",
            borderRadius: "2px",
            minWidth: "30vw",
            minHeight: "30vh",
            padding: "40px"
          }}
        >
          <Link to="/login">
            <div className="close-container">
              <div className="leftright"></div>
              <div className="rightleft"></div>
            </div>
          </Link>

          <Typography display="inline" variant="h5">
            Password Recovery
          </Typography>

          <div style={{ textAlign: "center" }}>
            <Typography variant="subtitle1" style={{ marginTop: "3vh" }}>
              Please enter your account email, and you will receive a reset
              link.
            </Typography>

            <TextField
              id="forgot-password"
              className={classes.textField}
              fullWidth={true}
              label="Email"
              name="email"
              margin="normal"
              inputRef={register({
                required: "Required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Invalid Email Address"
                }
              })}
            />

            {isError && (
              <Typography className={classes.linkContainer}>
                Email not found!
              </Typography>
            )}

            <Button
              variant="contained"
              size="large"
              color="primary"
              className={classes.recovery}
              onClick={handleSubmit(getRecovery)}
            >
              Submit
            </Button>

            {isSuccessfulText && (
              <Typography variant="subtitle2" style={{ marginTop: "2vh" }}>
                Password Recovery email sent.
              </Typography>
            )}
          </div>
        </Grid>
      </Grid>
      <AppBar className={classes.termsBar} position="static">
        <Toolbar>
          <span>© Sofar Ocean Technologies</span>
          <span className={classes.termLinks}>
            <a
              href="https://www.sofarocean.com/posts/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#FFF",
                padding: "0 1vw",
                textDecoration: "none"
              }}
            >
              Privacy Policy
            </a>
            <a
              href="https://www.sofarocean.com/posts/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#FFF",
                padding: "0 1vw",
                textDecoration: "none"
              }}
            >
              Terms of Use
            </a>
          </span>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Recovery;
